import React from "react";

type ToggleSwitchProps = {
    checked: boolean;
    onChange: (next: boolean) => void;
    disabled?: boolean;
};

export default function ToggleSwitch({
    checked,
    onChange,
    disabled = false,
}: ToggleSwitchProps) {
    return (
        <button
            type="button"
            disabled={disabled}
            onClick={() => onChange(!checked)}
            className={`relative inline-flex h-5 w-10 items-center rounded-full transition ${checked ? "bg-primary-red" : "bg-gray-300"
                } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        >
            <span
                className={`inline-block h-[14px] w-[14px] transform rounded-full bg-white transition ${checked ? "translate-x-6" : "translate-x-1"
                    }`}
            />
        </button>
    );
}
